import { Product } from '../../../utils/types/Product'

interface ProductCatalogModel {
  products?: Product[]
  isLoading?: boolean
  total?: number
}

class ProductCatalog implements ProductCatalogModel {
  products: ProductCatalogModel['products']

  isLoading: ProductCatalogModel['isLoading']

  total: ProductCatalogModel['total']

  constructor(model: ProductCatalogModel) {
    this.products = model.products
    this.isLoading = model.isLoading
    this.total = model.total
  }
}

export default ProductCatalog
